import { Ref } from 'react';

import { useToggle } from '@codex-brightworld/helpers';

type Props = {
  defaultOpen: boolean;
  /**
   * Pass `innerRef` to your wrapper to make this work.
   */
  closeOnOutsideClick: boolean;
  closeOnEscape: boolean;
  closeOnPageScroll: boolean;
  /**
   * @param {boolean} open
   */
  onToggle: (active: boolean) => void;
  /**
   * @param {Object} renderProps
   * @param {boolean} renderProps.open
   * @param {function} renderProps.toggle
   * @param {Object} renderProps.innerRef
   * @return {React.Node}
   */
  children: ({ open, toggle, innerRef }:
               { open: boolean; toggle: (active: boolean) => void; innerRef: Ref<unknown> }) => JSX.Element;
};

/**
 * @tags gadget, switch, toggle
 */
export const Toggleable = (props: Props) => {
  const [open, toggle, innerRef] = useToggle(
    props.defaultOpen,
    {
      clickOutside: props.closeOnOutsideClick,
      escape: props.closeOnEscape,
      scroll: props.closeOnPageScroll
    },
    props.onToggle
  );

  return props.children({ open, toggle, innerRef });
};

Toggleable.defaultProps = {
  closeOnOutsideClick: false,
  closeOnPageScroll: false,
  closeOnEscape: false,
  defaultOpen: false,
  onToggle: () => {
    // do nothing
  }
};

Toggleable.displayName = 'Toggleable';
